export const SET_NEW_BOX_PRODUCTS = "SET_NEW_BOX_PRODUCTS"

export const setNewBoxProducts = payload => (dispatch, getState) => {
  dispatch({ type: SET_NEW_BOX_PRODUCTS, payload })
}
